var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "mb-15" },
      [
        _c("strong", [_vm._v(_vm._s(_vm.$t("interchangeEventDetail.events")))]),
        _vm._v(" "),
        _c(
          "el-table",
          {
            ref: "eventTable",
            attrs: {
              data: _vm.rows,
              "highlight-current-row": "",
              "row-key": "reference",
              size: "small",
              "max-height": "280",
              "default-sort": { prop: "timestamp", order: "descending" }
            },
            on: { "current-change": _vm.handleCurrentChange }
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "timestamp",
                label: _vm.$t("interchangeEventDetail.createdAt"),
                width: "170",
                sortable: "",
                "sort-orders": ["ascending", "descending", null]
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.formatCreatedAt(scope.row)) +
                          "\n\t\t\t\t"
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "event_type",
                label: _vm.$t("interchangeEventDetail.eventType"),
                width: "140"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            size: "mini",
                            type: _vm.eventTypeTagType(scope.row.event_type)
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(scope.row.event_type) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "event_subtype",
                label: _vm.$t("interchangeEventDetail.eventSubtype"),
                "min-width": "210"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "interchange_channel",
                label: _vm.$t("interchangeEventDetail.channel"),
                width: "110"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("el-tag", { attrs: { size: "mini", type: "info" } }, [
                        _vm._v(_vm._s(scope.row.interchange_channel))
                      ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("interchangeEventDetail.interchange"),
                width: "120"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.shortInterchange(scope.row)) +
                          "\n\t\t\t\t"
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mb-15" }, [
      _c("strong", [
        _vm._v(_vm._s(_vm.$t("interchangeEventDetail.interpreted")))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-10" },
        [
          _vm.selectedRow
            ? _c(_vm.interpretedComponent, {
                tag: "component",
                attrs: { row: _vm.selectedRow }
              })
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "div",
          {
            staticClass: "disp-flex mb-10",
            staticStyle: { "align-items": "center" }
          },
          [
            _c("strong", [
              _vm._v(_vm._s(_vm.$t("interchangeEventDetail.rawData")))
            ]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "ml-auto",
                attrs: { size: "mini" },
                on: {
                  click: function($event) {
                    return _vm.copyRawData($event)
                  }
                }
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("interchangeEventDetail.copy")) +
                    "\n\t\t\t"
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("el-input", {
          attrs: {
            type: "textarea",
            rows: 16,
            value: _vm.rawJson(_vm.selectedRow),
            readonly: "",
            resize: "vertical"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }